/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface AssignmentAdherenceResponseDto
 */
export interface AssignmentAdherenceResponseDto {

    /**
     * @type {number}
     * @memberof AssignmentAdherenceResponseDto
     */
    assignmentId: number;

    /**
     * @type {number}
     * @memberof AssignmentAdherenceResponseDto
     */
    eventId: number;

    /**
     * @type {string}
     * @memberof AssignmentAdherenceResponseDto
     */
    expectedSessionDate: string;

    /**
     * @type {number}
     * @memberof AssignmentAdherenceResponseDto
     */
    expectedSets: number;
}
